import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Card, Embed, Icon, Label, Message } from 'semantic-ui-react'

import nunjucks from 'nunjucks'
import unified from 'unified'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import rehypeReact from 'rehype-react'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import slug from 'remark-slug'
//import externalLinks from 'remark-external-links'
import embedImages from 'remark-embed-images'
import { isEqual } from 'lodash'
import startsWith from 'lodash/startsWith'

import {
  ApiFeedUrlBrowser,
  ApiJsonContentBrowser,
  ApiWireqUrlBrowser,
  CodeBlockBrowser,
  FeedContentBrowser } from './cards'
import { ApiS3Push, ApiSftppush } from './push_apis'
import ApiGraphqlBrowser from './cards/ApiGraphqlBrowser'

import { findApi, findApp, findFeedInContext, findProfile } from '../all_cards/aufschaltung'
import placeholder_16x9 from '../resources/image-16by9.png'

// Mapping from html-inside-markdown to react components
const components = {
  // semantic ui components
  message: { _: Message },
  label: { _: Label },
  navlink: { _: NavLink, add_props: {as: 'a'} },
  embed: { _: Embed, add_props: {placeholder: placeholder_16x9} },

  // apikp components
  feedcontentbrowser: {_: FeedContentBrowser, with_context: true},
  codeblockbrowser: {_: CodeBlockBrowser, with_context: true},

  apijsoncontentbrowser: {_: ApiJsonContentBrowser, with_context: true},
  apifeedurlbrowser: {_: ApiFeedUrlBrowser, with_context: true, with_card_definition: true},
  apiwirequrlbrowser: {_: ApiWireqUrlBrowser, with_context: true, with_card_definition: true},

  apigraphqlbrowser: {_: ApiGraphqlBrowser, with_context: true, with_card_definition: true},
  apis3pushwizard: {_: ApiS3Push, with_context: true},
  apisftppushwizard: {_: ApiSftppush, with_context: true}
}

// delete remarkParse.Parser.prototype.inlineTokenizers.autoLink
delete remarkParse.Parser.prototype.inlineTokenizers.url

class MarkupComponent extends Component {

  render () {
    const { context } = this.props
    const { cardsInContext } = this.props
    return (
      <div className='cards-in-context'>
        {cardsInContext.map((card, index) => this.renderCard(context, card, index))}
      </div>
    )
  }

  make_pretty(tagexp) {
    /** Show special queries.
    */
    if (tagexp instanceof Object) {
      // special case e.g.
      // { "and":["dpasrv:erd","dpageneration:2014g"] }
      // { "and": [{"regexp": "dpasrv:(erd|hsh)"}, "dpageneration:2014g"] }
      // { "and": [{"regexp": "dpasrv:(labwire|bdt)"}, {"not": {"regexp": "dpageneration:.+"}}] }
      if (isEqual(Object.keys(tagexp), ['and'])) {
        if (tagexp['and'].length === 2 && tagexp['and'][1] === 'dpageneration:2014g') {
          const shown_tagexp = tagexp['and'][0];
          if (shown_tagexp instanceof Object && isEqual(Object.keys(shown_tagexp), ['regexp'])) {
            return `${shown_tagexp['regexp']} (monomedial)`;
          }
          return `${shown_tagexp} (monomedial)`
        }
        if (tagexp['and'].length === 2 && tagexp['and'][0] === 'dpageneration:2014g') {
          const shown_tagexp = tagexp['and'][1];
          if (shown_tagexp instanceof Object && isEqual(Object.keys(shown_tagexp), ['regexp'])) {
            return `${shown_tagexp['regexp']} (monomedial)`;
          }
          return `${shown_tagexp} (monomedial)`
        }
        if (tagexp['and'].length === 2 && isEqual(Object.keys(tagexp['and'][0]), ['regexp'])) {
          return `${tagexp['and'][0]['regexp']} (special)`;
        }
      }
      // TODO more special cases?
      return JSON.stringify(tagexp)
    }
    return tagexp
  }

  prepare_profile(profile) {
    if (!profile) {
      return profile
    }
    const prepare_ored_tag_regexp = (exp) => {
      if (startsWith(exp, 'dnlpath:')) {
        return {value: exp, kind: 'rubric', kind_title: 'Rubrik:', title: exp.replace('dnlpath:','')}
      } else if (startsWith(exp, 'dpasrv:')) {
        return {value: exp, kind:  'wire', kind_title: 'Wire:', title: exp.replace('dpasrv:','')}
      } else if (startsWith(exp, 'json64:')) {
        const tagr = this.make_pretty(JSON.parse(atob(exp.split('json64:')[1])));
        return { value: tagr, kind: 'wire', kind_title: 'Wire:', title: tagr.replace('dpasrv:','')}
      } else {
        return { value: exp,  kind: 'unknown', kind_title: '', title: exp }
      }
    }
    // TODO: remove once PROD in sync with DEV cf3 api
    const ored_tag_regexps = profile.ored_tag_regexps ? profile.ored_tag_regexps : profile.query_ored_tag_regexps
    return {
      ...profile,
      ored_tag_regexps:  ored_tag_regexps.map(prepare_ored_tag_regexp),
      query_ored_tag_regexps:  ored_tag_regexps.map(prepare_ored_tag_regexp)
    }
  }

  renderCard (context, card, index) {
    let titleMarkdown = null

    let descrMarkdown = null
    let description = card.description
    // TODO: fix
    //const withHelp = (card.data && JSON.parse(card.data).with_help) || false
    //const withMinify = (card.data && JSON.parse(card.data).with_minify) || false
    const withHelp = false
    const withMinify = false

    if (typeof description === 'string') {
      // assume single string is nunjicks/jinja2 template with markdown, eval template and convert markdown to html
      const _profile = findProfile({aufschaltung: context.aufschaltung}, {nickname: context.navigation.profile})
      const _api = findApi({aufschaltung: context.aufschaltung}, {nickname: context.navigation.api})
      const _feed = findFeedInContext(context.aufschaltung, _profile, _api)
      const env = {
        card,
        userInfo: context.userInfo,
        aufschaltung: context.aufschaltung,
        profile: this.prepare_profile(_profile),
        api: _api,
        feed: _feed,
        app: findApp({aufschaltung: context.aufschaltung}, {nickname: context.navigation.app})
      }

      try {
        titleMarkdown = nunjucks.renderString(card.title, env)
      } catch (err) {
        console.error(err)
        titleMarkdown = card.title
      }

      try {
        descrMarkdown = nunjucks.renderString(card.description, env)
      } catch (err) {
        console.error(err)
        descrMarkdown = null
        description = ['Error in description']
      }
    }

    return (
      <Card key={index} fluid>
        <Card.Content className='card-content'>
          { withHelp ? (<Icon name='question' circular style={{float: 'right'}} size='small' />) : null }
          <Card.Header>
            <a name={card.title.toLowerCase().replace(/ /g, '-')}>
              {titleMarkdown}
            </a>
          </Card.Header>
          <Card.Description className={descrMarkdown ? 'card-description-markdown' : 'card-description'}>
            { descrMarkdown ? this.renderMarkdown(descrMarkdown, context, card) : description.map(d => (<div>{d}</div>)) }
          </Card.Description>
          { withMinify ? (<Icon name='chevron up' circular style={{float: 'right'}} size='small' />) : null }
        </Card.Content>
      </Card>
    )
  }

  renderMarkdown (src, context, card) {
    function createElement (component, props, children) {
      let mappedComponent = (components && component && components[component])
      let mappedComponentProps = {}
      if (mappedComponent) {
        if (mappedComponent.with_context) {
          mappedComponentProps = { ...mappedComponentProps, context }
        }
        if (mappedComponent.with_card_definition) {
          mappedComponentProps = { ...mappedComponentProps, card }
        }
        if (mappedComponent.add_props) {
          mappedComponentProps = { ...mappedComponentProps, ...mappedComponent.add_props }
        }
        mappedComponent = mappedComponent._
      }
      const Tag = mappedComponent || component || 'div'
      const tagProps = {...props, ...mappedComponentProps}
      return (
        <Tag {...tagProps}>
          {children}
        </Tag>
      )
    }

    const processor = unified()
        .use(remarkParse)
        // .use(configure_remark_parser_plugin)
        // Place any remark plugins here
        // .use(remarkMermaid)
        .use(embedImages)
        // .use(externalLinks, {target: '_blank'})
        .use(slug)
        .use(remarkRehype, { allowDangerousHTML: true })
        .use(rehypeRaw)
        .use(rehypeHighlight)
        // Place any rehype plugins here
        .use(rehypeReact, { createElement })
    const result = processor.processSync(src).contents
    return result
  }
}

export default MarkupComponent



// WEBPACK FOOTER //
// ./src/components/MarkupComponent.js